<template functional>
  <v-list>
    <v-list-tile>
      <v-list-tile-title class="list-tile-title text-xs-center mt-4">{{ props.text }}</v-list-tile-title>
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  props: {
    text: String,
  },
};
</script>

<style lang="stylus" scoped>
@import "../../../../assets/stylus/variables.styl";

.list-tile-title {
  color: $nx-primary--lighten-3
  font-size: 16px
}
</style>
